import React from 'react'

import ExportTemplateModal from '../export/ExportTemplateModal.js'
import {getColumns} from '../../utils/csvExport.js'
import t from '../../helpers/Languages.js'

const newExportTemplate = {
    name: '',
    columns: ['order._id', 'order.date', 'order.customer'],
    method: 'order'
}

const defaultColumns = [
    'order.date',
    'order._id',
    'order.customer',
    'order.trackTrace',
    'order.status',
    'order.subStatus',
    'order.route',
    'order.messenger',
    'order.amountOfAddresses',
    'order.nrOfColli',
    'address.type',
    'address.name',
    'address.street',
    'address.nr',
    'address.addition',
    'address.postalCode',
    'address.city',
    'collo.barcode',
    'collo.type',
    'collo.status',
    'collo.reason'
]

export default function ExportOrders(props) {
    const {reseller, onChange, open, onClickExport, onClose} = props

    return (
        <ExportTemplateModal
            title={t('exportOrders')}
            open={open}
            onClose={onClose}
            templates={reseller.settings.orders.exportCsvTemplates}
            onSaveTemplates={(templates) => {
                reseller.settings.orders.exportCsvTemplates = templates
                onChange(reseller, 'orders.exportCsvTemplates')
            }}
            methods={[
                {value: 'order', title: t('exportPerOrder')},
                {value: 'address', title: t('exportPerAddress')},
                {value: 'collo', title: t('exportPerCollo')}
            ]}
            getColumns={(method) => getColumns(method, reseller)}
            defaultColumns={defaultColumns}
            newTemplate={newExportTemplate}
            onClickExport={onClickExport}
        />
    )
}
